import React, { forwardRef } from 'react';

import { DateTimePicker } from '@material-ui/pickers';

const DateInput = forwardRef(
  ({ handleEnter, handleKey, variant = 'outlined', ...rest }, ref) => (
    <DateTimePicker
      {...rest}
      inputRef={ref}
      autoFocus={false}
      onKeyDown={(e) => {
        if (e.keyCode === 13) handleEnter();
        else handleKey(e.keyCode, e.key);
      }}
      //variant="outlined"
    />
  ),
);

export default DateInput;
